import React, { PropsWithChildren, useState } from "react";
import { makeStyles, Tooltip } from "@material-ui/core";
import { ContentCopyIcon } from "@bonliva-crm/ui";
import { useLocale } from "@hooks";

type Props = PropsWithChildren & {
  contentToCopy: string;
};

export function WithCopyToClipboard({ children, contentToCopy }: Props) {
  const [copied, setCopied] = useState(false);
  const { locale } = useLocale();
  const classes = useStyles();

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className={classes.root}>
      <span>{children}</span>
      <span
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          copyToClipboard(contentToCopy);
          setCopied(true);
          setTimeout(() => setCopied(false), 500);
        }}
      >
        <Tooltip title={copied ? locale.Copied : locale.CopyToClipboard}>
          <span>
            <ContentCopyIcon className={classes.copyIcon} />
          </span>
        </Tooltip>
      </span>
    </div>
  );
}

const useStyles = makeStyles(() => ({
  root: {
    "&:hover > span > span > svg": {
      visibility: "visible"
    }
  },
  copyIcon: {
    visibility: "hidden",
    width: 16,
    height: 16,
    marginLeft: 6,
    cursor: "pointer",
    verticalAlign: "bottom"
  }
}));
